import React, { useState, useEffect } from "react";
import "./AddLeaves.css";
import { API_URL } from "./API";

const LeaveApplicationForm = ({ onBack, onLeaveAdded }) => {
  const [formData, setFormData] = useState({
    employeeId: "",
    employeeName: "",
    leaveType: "",
    fromDate: "",
    fromTime: "",
    toDate: "",
    toTime: "",
    reason: "",
    reportTo: "",
    totalDays: 0,
  });

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]); 

  useEffect(() => {
    const fetchCurrentEmployee = async () => {
      setLoading(true);
      try {
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        const currentUserId = currentUser?.id || currentUser?.employee_id || localStorage.getItem('currentUserId');
        
        if (currentUserId) {
          const res = await fetch(`${API_URL}/employees/get_employees`);
          const data = await res.json();
          
          
          if (data.status === "success") {
            const employeesList = data.employees || [];
            
           
            setAllEmployees(employeesList);
            
            const currentEmployee = employeesList.find(emp => 
              emp.id.toString() === currentUserId.toString() || 
              emp.employee_id?.toString() === currentUserId.toString()
            );
            
            if (currentEmployee) {
              setFormData((p) => ({ 
                ...p, 
                employeeId: currentEmployee.id.toString(), 
                employeeName: currentEmployee.name 
              }));
            } else {
             
              alert("Unable to load your employee details");
            }
          } else {
           
            alert("Failed to load employee data");
          }
        } else {
          alert("No user logged in");
        }
      } catch (error) {
       
        alert("Error loading employee data");
      }
      setLoading(false);
    };
    fetchCurrentEmployee();
  }, []);

  useEffect(() => {
    if (formData.fromDate && formData.fromTime && formData.toDate && formData.toTime) {
      const from = new Date(`${formData.fromDate}T${formData.fromTime}`);
      const to = new Date(`${formData.toDate}T${formData.toTime}`);
      
      if (to > from) {
        const hours = (to - from) / 3600000;
        let days = hours <= 4 ? 0.5 : hours <= 24 ? 1 : Math.floor(hours / 24) + (hours % 24 > 4 ? 1 : hours % 24 > 0 ? 0.5 : 0);
        setFormData((p) => ({ ...p, totalDays: days }));
      } else {
        setFormData((p) => ({ ...p, totalDays: 0 }));
      }
    }
  }, [formData.fromDate, formData.fromTime, formData.toDate, formData.toTime]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  
  const sendLeaveNotificationToAdmins = (leaveData) => {
    try {
      const notificationMessage = {
        id: Date.now() + Math.random(),
        type: 'leave_request',
        message: `${leaveData.employeeName} has applied for ${leaveData.leaveType} - ${leaveData.totalDays} ${leaveData.totalDays === 1 ? 'day' : 'days'} (${new Date(leaveData.fromDate).toLocaleDateString()} to ${new Date(leaveData.toDate).toLocaleDateString()})`,
        details: {
          employeeName: leaveData.employeeName,
          employeeId: leaveData.employeeId,
          leaveType: leaveData.leaveType,
          fromDate: leaveData.fromDate,
          toDate: leaveData.toDate,
          totalDays: leaveData.totalDays,
          reason: leaveData.reason,
          status: 'Pending'
        },
        timestamp: new Date().toISOString(),
        read: false
      };

    
      let employees = allEmployees;
      
      
      if (!employees || employees.length === 0) {
        const storedData = localStorage.getItem('allEmployeesData');
        if (storedData) {
          employees = JSON.parse(storedData);
        }
      }

      if (employees && employees.length > 0) {
       
        const adminUsers = employees.filter(emp => {
          const role = (emp.role || '').toUpperCase();
          return role.includes('CEO') || 
                 role.includes('ADMIN') || 
                 role.includes('ASSISTANT ADMIN') ||
                 role === 'ADMINISTRATOR';
        });

     

        if (adminUsers.length === 0) {
        
          return;
        }

        
        adminUsers.forEach(admin => {
          const adminId = admin.id || admin.employee_id;
          const storageKey = `notifications_${adminId}`;
          
        
          const existingNotifications = JSON.parse(
            localStorage.getItem(storageKey) || '[]'
          );
          
         
          existingNotifications.unshift(notificationMessage);
          
        
          localStorage.setItem(storageKey, JSON.stringify(existingNotifications));
          
          
        });

        
        window.dispatchEvent(new Event('notificationUpdate'));
        window.dispatchEvent(new StorageEvent('storage', {
          key: 'notificationUpdate',
          newValue: Date.now().toString()
        }));
        
       
      } else {
        
        
       
        fetch(`${API_URL}/employees/get_employees`)
          .then(res => res.json())
          .then(data => {
            if (data.status === "success" && data.employees) {
              const adminUsers = data.employees.filter(emp => {
                const role = (emp.role || '').toUpperCase();
                return role.includes('CEO') || 
                       role.includes('ADMIN') || 
                       role.includes('ASSISTANT ADMIN');
              });

              adminUsers.forEach(admin => {
                const adminId = admin.id || admin.employee_id;
                const existingNotifications = JSON.parse(
                  localStorage.getItem(`notifications_${adminId}`) || '[]'
                );
                existingNotifications.unshift(notificationMessage);
                localStorage.setItem(
                  `notifications_${adminId}`,
                  JSON.stringify(existingNotifications)
                );
            
              });

              window.dispatchEvent(new Event('notificationUpdate'));
            }
          })
          .catch(err => console.error('Error fetching employees for notification:', err));
      }
    } catch (error) {
     
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { employeeId, leaveType, fromDate, toDate, reason, totalDays, reportTo } = formData;

    if (!employeeId || !leaveType || !fromDate || !toDate || !reason.trim() || totalDays <= 0) {
      alert("Please fill all required fields correctly");
      return;
    }

    setSubmitting(true);
    
    const payload = {
      employee_id: parseInt(employeeId),
      reason: reason.trim(),
      total_days: totalDays,
      leave_type: leaveType,
      from_date: fromDate,
      to_date: toDate,
      report_to: reportTo.trim() || "Not Assigned"
    };

    

    try {
      const response = await fetch(`${API_URL}/payslips/create_employee_leave`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(payload),
      });

     
      const result = await response.json();
      

      if (response.ok && result.status === "success") {
       

        const newLeave = {
          id: result.data?.leave_id || Date.now(),
          employeeId: parseInt(employeeId),
          employeeName: formData.employeeName,
          leaveType: formData.leaveType,
          fromDate: formData.fromDate,
          fromTime: formData.fromTime,
          toDate: formData.toDate,
          toTime: formData.toTime,
          reason: formData.reason,
          reportTo: formData.reportTo || "Not Assigned",
          totalDays: formData.totalDays,
          status: "Pending",
          appliedDate: new Date().toLocaleDateString(),
        };

        
        sendLeaveNotificationToAdmins({
          employeeName: formData.employeeName,
          employeeId: parseInt(employeeId),
          leaveType: formData.leaveType,
          fromDate: formData.fromDate,
          toDate: formData.toDate,
          totalDays: formData.totalDays,
          reason: formData.reason
        });

        
        onLeaveAdded?.(newLeave);
        alert("Leave applied successfully!");

       
        setFormData({
          employeeId: formData.employeeId,
          employeeName: formData.employeeName,
          leaveType: "",
          fromDate: "",
          fromTime: "",
          toDate: "",
          toTime: "",
          reason: "",
          reportTo: "",
          totalDays: 0,
        });
      } else {
       
        const errorMessage = result.message || result.error || "Failed to submit leave application";
        alert(errorMessage);
      }
    } catch (error) {
     
      alert("Failed to submit leave application. Please check your connection and try again.");
    }
    
    setSubmitting(false);
  };

  return (
    <div className="AL-00">
      <div className="AL-01">
        <h2 className="AL-02">Add Leaves</h2>
        <form onSubmit={handleSubmit}>
          
          <div className="AL-03">
            <label className="AL-04">Employee</label>
            <input 
              type="text" 
              value={loading ? "Loading..." : formData.employeeName || "No employee found"} 
              className="AL-05" 
              disabled
              readOnly
              style={{ 
                backgroundColor: '#f5f5f5', 
                cursor: 'not-allowed',
                color: '#333'
              }}
            />
          </div>

          <div className="AL-03">
            <label className="AL-04">Leave Type</label>
            <select 
              name="leaveType" 
              value={formData.leaveType} 
              onChange={handleChange} 
              className="AL-05"
              required
            >
              <option value="">Select Leave Type</option>
              <option value="Casual leave">Casual Leave</option>
              <option value="Sick leave">Sick Leave</option>
            </select>
          </div>

          <div className="AL-06">
            <div className="AL-07">
              <label className="AL-04">From</label>
              <div className="AL-08">
                <input 
                  type="date" 
                  name="fromDate" 
                  value={formData.fromDate} 
                  onChange={handleChange} 
                  className="AL-09"
                  required
                />
                <input 
                  type="time" 
                  name="fromTime" 
                  value={formData.fromTime} 
                  onChange={handleChange} 
                  className="AL-10"
                  required
                />
              </div>
            </div>
            <div className="AL-07">
              <label className="AL-04">To</label>
              <div className="AL-08">
                <input 
                  type="date" 
                  name="toDate" 
                  value={formData.toDate} 
                  onChange={handleChange} 
                  className="AL-09"
                  required
                />
                <input 
                  type="time" 
                  name="toTime" 
                  value={formData.toTime} 
                  onChange={handleChange} 
                  className="AL-10"
                  required
                />
              </div>
            </div>
          </div>

          <div className="AL-03">
            <label className="AL-04">Report To</label>
            <input 
              type="text" 
              name="reportTo"
              value={formData.reportTo}
              onChange={handleChange}
              className="AL-05"
              placeholder="Enter Name (Optional)"
            />
          </div>

          <div className="AL-03">
            <label className="AL-04">Reason</label>
            <textarea 
              name="reason" 
              value={formData.reason} 
              onChange={handleChange} 
              className="AL-11" 
              rows="3" 
              placeholder="Enter Reason"
              required
            />
          </div>

          <div className="AL-03">
            <label className="AL-04">Total Days:</label>
            <div className="AL-12">
              {formData.totalDays === 0.5
                ? "0.5 (Half Day)"
                : formData.totalDays === 1
                ? "1 (Full Day)"
                : formData.totalDays > 1
                ? `${formData.totalDays} Days`
                : "0"}
            </div>
          </div>

          <div className="AL-13">
            <button type="button" onClick={onBack} className="AL-14" disabled={submitting}>
              Back
            </button>
            <button type="submit" className="AL-15" disabled={submitting || loading}>
              {submitting ? "Adding..." : "Add Leave"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeaveApplicationForm;